export const COMPANY_BACKGROUND = "Company Background";
export const RO_ADDITIONAL_COMMENTS = "Additional comments by RO";
export const RM_ADDITIONAL_COMMENTS = "Additional comments by RM";
export const SO_ADDITIONAL_COMMENTS = "Additional comments by SM/Unit Head";
export const HOD_ADDITIONAL_COMMENTS = "Additional comments by HOD";
export const OTHER_CONTACT_DESIGNATION = "DES5";
export const MAX_COMPANY_BACKGROUND_LENGTH = 1000;
